import './styles/index.css';
import Nav from './components/NavBar';
import Homes from './pages/Home';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Forms from './pages/Simulation';
import Contact from './pages/Contact';
import CardsContainer from './components/Card/CardsContainer';
import { Previsionnel } from './pages/Previsionnel';
import Success from './components/Success';
import Fonction from './components/RoadMap';
import Footer from './components/Footer';
import FormJuridic from './pages/FormJuridic';
import MentionsLegales from './pages/MentionsLegales';

import { Helmet } from "react-helmet";


const App = () => {







  return (

    <>
      <Helmet>
        <meta name="description" content="Que vous soyez un artisan, un commerçant, un libéral ou un consultant, notre simulateur vous aide à choisir la forme juridique idéale pour créer votre entreprise ou société. Profitez d'une simulation précise pour orienter votre décision et planifier votre budget prévisionnel." />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "FB Conseils",
            "url": "https://maformejuridique.fr",
            "logo": "https://maformejuridique.fr/img/FBConseil_Logo_RVB-07.jpg.jpeg",
            "description": "Expert en création d'entreprise, choix de forme juridique et budget prévisionnel.",
            "contactPoint": {
              "@type": "ContactPoint",
              "contactType": "customer service",
              "availableLanguage": "French"
            },
            "address": {
              "@type": "PostalAddress",
              "addressCountry": "FR"
            }
          }
        `}</script>
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Ma Forme Juridique",
            "url": "https://maformejuridique.fr",
            "description": "Simulateur de forme juridique et budget prévisionnel pour la création d'entreprise",
            "publisher": {
              "@type": "Organization",
              "name": "FB Conseils"
            }
          }
        `}</script>
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Conseil en création d'entreprise",
            "provider": {
              "@type": "Organization",
              "name": "FB Conseils"
            },
            "areaServed": {
              "@type": "Country",
              "name": "France"
            },
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Nos offres",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "name": "Budget prévisionnel automatisé",
                  "price": "59",
                  "priceCurrency": "EUR"
                },
                {
                  "@type": "Offer",
                  "name": "Rendez-vous conseil",
                  "price": "99",
                  "priceCurrency": "EUR"
                },
                {
                  "@type": "Offer",
                  "name": "Formule complète",
                  "price": "249",
                  "priceCurrency": "EUR"
                }
              ]
            }
          }
        `}</script>
      </Helmet>

      <Router>
        <Nav />
        <Routes>
          <Route path="/" element={<Homes />} />
          <Route path="/form" element={<Forms />} />
          <Route path="/success" element={<Success />} />
          <Route path="/fonctionnement" element={<Fonction />} />
          <Route path="/cards" element={<CardsContainer />} />
          <Route path="/previsionnel" element={<Previsionnel />} />
          <Route path="/juridique" element={<FormJuridic />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/cancel" element={<Navigate to="/form" replace />} />







        </Routes>
        <div className="footer-wrapper mt-28">
          <Footer />
        </div>
      </Router>

    </>
  );
};

export default App;
